import {
    useMemo,
} from 'react'

import useLabel from 'app/hooks/useLabel'
import DuplicationCheckDialog from 'app/shared-components/DuplicationCheckDialog'

import {
    ContactDuplication,
} from '../Contacts.types'
import getColumns from './ContactDuplicationDialog.columns'
import useStyles from './ContactDuplicationDialog.styles'

type Props = {
    data?: ContactDuplication[]
    close: () => void,
    action: (...args: any[]) => void,
    title: string,
    positiveLabel: string,
}

const defaultProps: Partial<Props> = {
    data: null,
}

const ContactDuplicationDialog = ({
    data,
    action,
    title,
    positiveLabel,
    close,
}: Readonly<Props>) => {
    const label = useLabel()
    const {
        classes,
    } = useStyles()

    const columns = useMemo(() => {
        return getColumns({
            label,
        })
    }, [label])

    return (
        <DuplicationCheckDialog<ContactDuplication>
            columns={columns}
            close={close}
            create={action}
            message="There are similar contacts already in the system. Please make sure you are not creating a duplicate."
            data={data}
            title={title}
            positiveLabel={positiveLabel}
            dialogClassName={classes.dialog}
        />
    )
}

ContactDuplicationDialog.defaultProps = defaultProps

export default ContactDuplicationDialog
